<template>
		<el-col>
				<common-table :data="BaseDictionaryList">
						<!-- <common-table-column label="序号" prop="typeID"/> -->
						<common-table-column label="类型" prop="dictType"/>
						<common-table-column label="名称" prop="dictName"/>
						<!-- <common-table-column label="说明" prop="remark"/>
						<common-table-column label="使用媒介" prop="mediumName"/> -->
						<common-table-column label="创建时间" prop="rowTime"/>
						<el-table-column label="操作" align="center">
								<template slot-scope="scope">
										<el-button type="text" @click="onItemEditClick(scope.row)">修改</el-button>
										<el-button type="text" @click="onItemDelete(scope.row)">删除</el-button>
								</template>
						</el-table-column>
				</common-table>
			<edit-data-object-dialog :visible.sync="editDataObjectDialogVisible" :current-item="currentItem"/>
		</el-col>
</template>

<script>
import CommonTable from "@/components/CommonTable";
import CommonTableColumn from "@/components/CommonTableColumn";
import {mapGetters} from "vuex";
import {BaseDictionaryDelete} from "@/api/setting";
import {getToken} from "@/utils/auth";
import EditDataObjectDialog from "@/views/System/Setting/Dictionary/EditDataObjectDialog";
import {dealDeleteOperation} from "@/utils/tools";

export default {
		name: "DataObjectTable",
		components: {EditDataObjectDialog, CommonTableColumn, CommonTable},
		computed: {...mapGetters(['BaseDictionaryList'])},
		data() {
				return {
						editDataObjectDialogVisible: false,
						currentItem:{}
				}
		},
		async created() {
		},
		methods: {
				async onItemEditClick(item) {
						console.log(item);
						this.currentItem = item;
						this.editDataObjectDialogVisible = true;
						//编辑成功后发
						// await this.$store.dispatch('base/BaseMediaList',);
				},
				async onItemDelete(item) {
						console.log(item);
						await dealDeleteOperation({deletePromise:BaseDictionaryDelete({userId: getToken(), dictId: item.dictID})})
						await this.$store.dispatch('setting/BaseDictionaryList',);
				},

		}
}
</script>

<style scoped>

</style>